<template>
  <div>
    <!--    First Version Caspian-->
    <transition
      name="animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
      appear
    >
      <b-row v-if="getVersion === 'v1' && !getGlobalApiRequestPending">
        <b-col lg="7" class="d-none d-lg-block mt-10">
          <b-container>
            <img src="@/assets/images/background1.png" width="100%" />
          </b-container>
          <b-col cols="12">
            <b-container class="mt-10">
              <h1 class="text-center font-size-xl pb-3">
                {{ $translate("tronGateway") }}
              </h1>
            </b-container>
          </b-col>
        </b-col>
        <b-col cols="12" lg="5">
          <shetab-stepper class="shetabStepper"></shetab-stepper>
          <!--        First Container for (Tether) Notice-->
          <b-container
            v-if="getStepperPage === 'pageOne'"
            id="tetherNoticePage"
            class="background-secondary border-radius-10px border-light-gray-1px my-3 pt-3"
          >
            <b-col class="flex-centering title-text pb-4 position-relative">
              <span>{{ $translate("attention") }}!!!</span>
              <button
                class="position-absolute back-button-position back-button"
                @click="goToCryptoGroup()"
              >
                {{ $translate("back") }}
              </button>
            </b-col>
            <b-col class="steel-blue-text font-size-medium pb-2">
              <!-- <p v-if="getSiteIdFiveCondition && getSiteRatesDisplayCondition">
                {{ $translate("eachTetherPriceInThisMoment") }}
                <span class="font-weight-bold red-text">{{
                  getTetherCurrentPrice | commaSep | persianDigit
                }}</span>
                {{ $translate("isToman") }}.
              </p>
              <p>
                {{ $translate("minimumTetherBuyAmount") }}
                <span class="font-weight-bold red-text">{{
                  2 | commaSep | persianDigit
                }}</span>
                {{ $translate("isDollar") }}.
              </p> -->
              <p v-if="getSiteIdFiveCondition && getSiteRatesDisplayCondition">
                {{ $translate("eachTronPriceInThisMoment") }}

                <span class="font-weight-bold red-text">{{
                  getTronCurrentPrice | commaSep | persianDigit
                }}</span>
                {{ $translate("isToman") }}.
              </p>

              <p>
                {{ $translate("minimumTronBuyAmount") }}
                <span class="font-weight-bold red-text">{{
                  5 | commaSep | persianDigit
                }}</span>
                {{ $translate("isTron") }}.
              </p>
            </b-col>
            <b-col class="details-text">
              <p>
                {{ $translate("attentionTransactionsWith") }}
                <span class="font-weight-bold black-text">
                  {{ $translate("tether") }}
                </span>
                {{ $translate("and") }}
                <span class="font-weight-bold black-text">
                  {{ $translate("tron") }}
                </span>
                {{ $translate("type") }}
                <span class="font-weight-bold black-text"> TRC20 </span>
                {{ $translate("onlyAreAcceptable") }}.
              </p>
            </b-col>
            <!--          75% Padding is for making this page's height as equal as shetabs-->
            <b-col class="details-text pb-4">
              <p>
                {{ $translate("tronPurchaseInfo") }}
              </p>
              <br />
              <p>
                {{ $translate("followingWalletOnlyFor") }}
                <span class="red-text font-weight-bold">
                  {{ $translate("once") }} </span
                >{{ $translate("acceptableCryptoTransaction") }}
              </p>
            </b-col>
            <b-row class="pb-4">
              <b-col cols="4">
                <button
                  type="button"
                  class="declineButton"
                  @click="cancelPayment"
                >
                  {{ $translate("cancel") }}
                </button>
              </b-col>
              <b-col cols="8">
                <button
                  type="button"
                  class="go-to-next-button"
                  @click="getTetherWallet()"
                >
                  <b-row class="fill-width">
                    <b-col cols="10">{{ $translate("showWallet") }}</b-col>
                    <b-col cols="2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="currentColor"
                        class="bi bi-arrow-left-short"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                        />
                      </svg>
                    </b-col>
                  </b-row>
                </button>
              </b-col>
            </b-row>
            <b-col class="flex-centering pb-4">
              <button
                type="button"
                class="go-to-next-button background-info-primary font-weight-bold"
                @click="openVideoPlayer"
              >
                <span class="info-secondary-text">
                  {{ $translate("helper") }}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-info-circle info-secondary-text"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                  />
                  <path
                    d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                  />
                </svg>
              </button>
            </b-col>
          </b-container>
          <!--        /First Container for (Tether) Notice-->

          <!--        Second Container for (Tether) Show Wallet and Payment Information-->
          <b-row v-if="getStepperPage === 'pageTwo'">
            <b-col
              cols="12"
              v-if="checkTransactionResultInterval"
              class="flex-centering"
            >
              <LoadingSpinner />
            </b-col>
            <b-col
              class="details-text flex-centering"
              v-if="getSiteRatesDisplayCondition"
            >
              <p class="mb-0">
                {{ $translate("eachTronPrice") }}
                <span class="red-text font-weight-bold">{{
                  getTronCurrentPrice | commaSep | persianDigit
                }}</span>
                {{ $translate("toman") }}
              </p>
            </b-col></b-row
          >
          <b-container
            v-if="getStepperPage === 'pageTwo'"
            id="showWalletPage"
            class="background-secondary border-radius-10px border-light-gray-1px my-3 pt-3"
          >
            <b-col class="flex-centering midnight-blue-text pb-3">
              <p class="mb-0">
                {{ $translate("depositAmountToTheWalletBelow") }}.
              </p>
            </b-col>
            <b-col class="midnight-blue-text d-flex pr-4 pb-4">
              <span> {{ $translate("yourDedicatedWallet") }}: </span>
            </b-col>
            <b-col class="flex-centering">
              <qr-code
                :text="walletAddress"
                class="pb-4"
                color="midnightblue"
                bg-color="#e2e6ea"
              ></qr-code>
            </b-col>
            <b-col class="flex-centering pb-4">
              <button
                @click.stop.prevent="copyToClipboard"
                class="border-none background-transparent"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  v-if="!copyToClipboardResult"
                  class="bi bi-clipboard-data"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z"
                  />
                  <path
                    d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                  />
                  <path
                    d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  v-if="copyToClipboardResult"
                  class="bi bi-clipboard-check"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                  />
                  <path
                    d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                  />
                  <path
                    d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                  />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  v-if="copyToClipboardFailed"
                  class="bi bi-clipboard-x"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708z"
                  />
                  <path
                    d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
                  />
                  <path
                    d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
                  />
                </svg>
              </button>
              <input
                class="form-control wallet-address-input midnight-blue-text font-weight-bold"
                type="text"
                id="walletAddress"
                v-model="walletAddress"
                readonly
              />
            </b-col>
            <b-col class="pt-4">
              <p class="midnight-blue-text">
                {{ $translate("yourDedicatedWalletAddressWillExpireIn") }}:
              </p>
            </b-col>
            <b-col class="pb-4">
              <span
                class="flex-centering red-text font-size-xl font-weight-bold"
              >
                <Timer
                  ref="TronTimer"
                  :duration="walletTimeRemain"
                  :timerKey="'tetherWallet'"
                  :persianTimer="true"
                  @expired="timerExpiredAlert"
                />
                <!--                <span> {{ expiresInHours }} </span>-->
                <!--                ساعت و-->
                <!--                <span> {{ expiresInMinutes }} </span>-->
                <!--                دقیقه و-->
                <!--                <span> {{ expiresInSeconds }} </span>-->
                <!--                ثانیه-->
              </span>
            </b-col>
          </b-container>
          <!--        /Second Container for (Tether) Show Wallet and Payment Information-->
        </b-col>
        <!--      <VideoPlayer v-if="showVideo" @closeVideoClickedOutSide="clickedOutSideOfVideo" :videoAddress="videoAddress"/>-->
      </b-row>
    </transition>
    <!--    /First Version Caspian-->
  </div>
</template>
<script>
// import VideoPlayer from "@/components/VideoPlayer";
import shetabStepper from "@/components/ShetabStepper";
import { tronMixin } from "@/mixins/TronMixin";
import Timer from "@/components/Timer";
import LoadingSpinner from "../../helper/component/LoadingSpinner.vue";

export default {
  name: "Tron",
  components: {
    Timer,
    shetabStepper: shetabStepper,
    LoadingSpinner,
    // VideoPlayer,
  },
  mixins: [tronMixin],
};
</script>

<style scoped>
.title-text {
  color: midnightblue;
  font-size: 1.2rem;
  font-weight: bold;
}

.details-text {
  color: steelblue;
  font-size: 1rem;
}

.go-to-next-button {
  width: 100%;
  padding: 5px;
  border: none !important;
  border-radius: 10px;
  background-color: dodgerblue;
  color: white;
}
.back-button {
  font-size: 0.9rem;
  padding: 4px;
  box-shadow: none;
  padding-inline: 8px;
  border-radius: 10px;
  border: 1px solid var(--black);
  background-color: transparent;
}
.back-button-position {
  left: 4%;
}

.declineButton {
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  border: 1px solid black;
  background-color: transparent;
}

.flex-centering {
  display: flex;
  justify-content: center;
  align-items: center;
}

.shetabStepper {
  padding-bottom: 30px;
}

.wallet-address-input {
  font-size: 1rem !important;
}

@media only screen and (max-width: 1450px) {
  .wallet-address-input {
    font-size: 0.75rem !important;
  }
}

@media only screen and (max-width: 1200px) {
  .wallet-address-input {
    font-size: 0.68rem !important;
  }
}

@media only screen and (max-width: 990px) {
  .wallet-address-input {
    font-size: 0.75rem !important;
  }
}

@media only screen and (max-width: 380px) {
  .wallet-address-input {
    font-size: 0.68rem !important;
  }
}
</style>
